import { Loader2 } from "lucide-react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { useUserPreferences } from "@/hooks/useUserPreferences";

export const ChatPreferences = () => {
  const { preferences, loading, updatePreferences } = useUserPreferences();

  if (loading) {
    return (
      <Card>
        <CardContent className="flex items-center justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Chat Display Preferences</CardTitle>
        <CardDescription>
          Customize how chat responses are displayed
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between space-x-2">
          <div className="space-y-0.5 flex-1">
            <Label htmlFor="collapse-enabled">Collapse Long Responses</Label>
            <p className="text-sm text-muted-foreground">
              Automatically collapse lengthy AI responses with a "Read more" button
            </p>
          </div>
          <Switch
            id="collapse-enabled"
            checked={preferences.chat_collapse_enabled}
            onCheckedChange={(checked) =>
              updatePreferences({ chat_collapse_enabled: checked })
            }
          />
        </div>

        {preferences.chat_collapse_enabled && (
          <div className="space-y-2 pl-4 border-l-2 border-muted animate-fade-in">
            <Label htmlFor="collapsed-height">Initial Collapsed Height</Label>
            <Select
              value={preferences.chat_collapsed_height.toString()}
              onValueChange={(value) =>
                updatePreferences({ chat_collapsed_height: parseInt(value) })
              }
            >
              <SelectTrigger id="collapsed-height">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="200">Small (200px)</SelectItem>
                <SelectItem value="300">Medium (300px)</SelectItem>
                <SelectItem value="400">Large (400px)</SelectItem>
                <SelectItem value="600">Extra Large (600px)</SelectItem>
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              Long responses will be collapsed to this height. You can expand them by clicking
              "Read more" or by scrolling down within the collapsed area.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
